import { CSSProperties, FC } from 'react';

import classes from './chat.module.css';

type ChatCodeBlockProps = {
  code: string;
  onClose: () => void;
  closeText?: string;
};

const styles: Record<string, CSSProperties> = {
  container: {
    marginTop: '0.5rem',
  },
};

const ChatCodeBlock: FC<ChatCodeBlockProps> = ({
  code,
  onClose,
  closeText = 'Hide',
}) => {
  return (
    <div style={styles.container}>
      <div className={classes.markdownCodeBlock}>
        <div className={classes.codeBlockCloseButtonPill} onClick={onClose}>
          {closeText}
        </div>
        {code}
      </div>
    </div>
  );
};

export default ChatCodeBlock;
